<!-- 我的订单中转页：APP「我的订单」入口，按订单类型分发跳转：
     1. 健萌健身会员卡订单 → APP 自研商城 webview（/ecShop 路由，isGetShopToken=1 由 APP 注入商城 token）
     2. 星球综训馆订单 → 综训馆 H5 我的订单（/web 通用 webview 打开，URL 携带当前登录 token）
     3. 商城订单 → 微盟商城我的订单（/web 通用 webview 打开，见 $betterwe.jumpWeb） -->
<template>
  <div class="my-orders-entry">
    <div class="page-title">请选择您要查询的订单类型</div>
    <div
      class="order-item"
      v-for="item in orderTypes"
      :key="item.type"
      @click="item.handler()"
    >
      <div class="order-icon">
        <img :src="item.icon" alt="" />
      </div>
      <div class="order-name">{{ item.name }}</div>
      <van-icon class="order-arrow" name="arrow" />
    </div>
  </div>
</template>

<script>
/** 健萌健身会员卡订单：APP 自研商城「我的订单」页（status=0 全部订单），
 *  title=我的订单、isGetShopToken=1（APP 注入商城 token）、isLogin=1（需登录态） */
const JM_CARD_ORDER = {
  test: '/ecShop?url=https%3A%2F%2Ftshoph5.gymcity.com.cn%2Fsubpage%2Fpages%2Ftrade%2Flist%3Fstatus%3D0&title=%E6%88%91%E7%9A%84%E8%AE%A2%E5%8D%95&isShowTitle=true&isGetShopToken=1&isLogin=1',
  pro: '/ecShop?url=https%3A%2F%2Fshoph5.gymcity.com.cn%2Fsubpage%2Fpages%2Ftrade%2Flist%3Fstatus%3D0&title=%E6%88%91%E7%9A%84%E8%AE%A2%E5%8D%95&isShowTitle=true&isGetShopToken=1&isLogin=1'
}
/** 星球综训馆订单：综训馆 H5「我的订单」页，token 由页面拼在 query 上 */
const ZXG_ORDER = {
  test: 'https://tsport.betterwestar.com/pages/my-orders/index',
  pro: 'https://sport.betterwestar.com/pages/my-orders/index'
}
/** 商城订单：微盟商城「我的订单」页（不分环境，URL 由需求方提供） */
const WM_ORDER_URL =
  '/wmOtherPage?fromType=11&url=https%3A%2F%2Fn.weimob.com%2Fsaas%2Fpayment%2Fweixinpay%2Fmall_orderlist%3Fpiid%3D2583540846%26vid%3D0%26cid%3D187447846%26ssharewid%3D1500729364%26share_vid%3D6001490628846%26pmc%3D3%257C5.essharewid.0-3.vid.0-2%257C3%257C5.share_vid.86400&title=%E5%95%86%E5%9F%8E%E8%AE%A2%E5%8D%95&appLinkUseTypeId=1&appRouterPagesId=3&appRouterId=752'

export default {
  name: 'my-orders-entry',
  data() {
    return {
      orderTypes: [
        {
          type: 'jmCard',
          name: '健萌健身会员卡订单',
          icon: 'https://gympic.gymcity.com.cn/uploads-add/202610/myorder-trans-jm',
          handler: this.toJmCardOrder
        },
        {
          type: 'zxg',
          name: '星球综训馆订单',
          icon: 'https://gympic.gymcity.com.cn/uploads-add/202610/myorder-trans-zxg',
          handler: this.toZxgOrder
        },
        {
          type: 'wm',
          name: '商城订单',
          icon: 'https://gympic.gymcity.com.cn/uploads-add/202610/myorder-trans-wm',
          handler: this.toWmOrder
        }
      ]
    }
  },
  methods: {
    // 三类订单均需在 APP 内跳转（依赖 APP webview 路由）
    checkApp() {
      if (!this.$betterwe.isApp()) {
        this.$toast('请在APP内查看订单')
        return false
      }
      return true
    },
    // 健萌健身会员卡订单：走 APP 自研商城路由
    toJmCardOrder() {
      if (!this.checkApp()) return
      const url =
        this.$http.curEv() === 'pro' ? JM_CARD_ORDER.pro : JM_CARD_ORDER.test
      this.$betterwe.jumpRoute(url)
    },
    // 星球综训馆订单：综训馆 H5 需要 APP 登录 token，走 /web 通用 webview 路由
    toZxgOrder() {
      if (!this.checkApp()) return
      const base = this.$http.curEv() === 'pro' ? ZXG_ORDER.pro : ZXG_ORDER.test
      const token = localStorage.getItem('token') || ''
      this.$betterwe.jumpWeb(base + '?token=' + token)
    },
    // 商城订单（微盟）：转成 APP /web 路由格式打开
    toWmOrder() {
      if (!this.checkApp()) return
      this.$betterwe.jumpRoute(WM_ORDER_URL)
    }
  }
}
</script>

<style lang="scss" scoped>
.my-orders-entry {
  min-height: 100vh;
  box-sizing: border-box;
  background: #fff;
  padding: 30px 20px 0;

  .page-title {
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    color: #050b27;
    line-height: 25px;
    margin-bottom: 26px;
  }

  .order-item {
    width: 100%;
    height: 84px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    padding: 0 20px;
    background: #fff;
    color: #000000;
    border-radius: 8px;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.06);

    .order-icon {
      width: 42px;
      height: 42px;
      margin-right: 17px;
      flex-shrink: 0;

      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }

    .order-name {
      flex: 1;
      font-size: 18px;
      color: #000;
    }

    .order-arrow {
      color: #c8c9cc;
      font-size: 14px;
    }
  }
}
</style>
